import { render, staticRenderFns } from "./EndCampaignButton.vue?vue&type=template&id=ddce4c4e&"
import script from "./EndCampaignButton.vue?vue&type=script&lang=js&"
export * from "./EndCampaignButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports